module.exports = __webpack_public_path__ + "img/pin.335a7f47.png";